module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/cup-icon-7f2abf0d643d3f5a1da14b4ea9c2e25f.svg";